import { render, staticRenderFns } from "./ProductInOverview.vue?vue&type=template&id=741c156e"
import script from "./ProductInOverview.vue?vue&type=script&lang=ts"
export * from "./ProductInOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports